"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formControlDisabledVariant = exports.formControlFocusVariant = exports.formControlPlaceholder = exports.formControlColorVariant = exports.formControlSizeVariant = exports.formControlBasic = exports.FormControlSuccess = exports.FormControlError = exports.FormControlFocused = exports.FormControlDisabled = exports.FormControlDefault = exports.FormControlSize = exports.FormControlLg = exports.FormControlMd = exports.FormControlSm = void 0;

var _const = require("../../const");

var _utils = require("../../utils");

var _icon = require("../icon/icon.styled");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FormControlSm = {
  height: 44,
  fontSize: 12,
  lineHeight: 22,
  paddingVertical: 10,
  paddingHorizontal: 15
};
exports.FormControlSm = FormControlSm;
var FormControlMd = {
  height: 52,
  fontSize: 12,
  lineHeight: 30,
  paddingVertical: 10,
  paddingHorizontal: 15
};
exports.FormControlMd = FormControlMd;
var FormControlLg = {
  height: 56,
  fontSize: 14,
  lineHeight: 36,
  paddingVertical: 10,
  paddingHorizontal: 15
};
exports.FormControlLg = FormControlLg;
var FormControlSize = {
  sm: FormControlSm,
  md: FormControlMd,
  lg: FormControlLg
};
exports.FormControlSize = FormControlSize;
var FormControlDefault = {
  color: _const.Colors.gray800,
  placeholderColor: _const.Colors.gray500,
  border: "1px solid ".concat(_const.Colors.gray700)
};
exports.FormControlDefault = FormControlDefault;
var FormControlDisabled = {
  color: _const.Colors.gray500,
  backgroundColor: _const.Colors.gray100,
  border: "1px solid ".concat(_const.Colors.gray300)
};
exports.FormControlDisabled = FormControlDisabled;
var FormControlFocused = {
  border: "1px solid ".concat(_const.Colors.primary)
};
exports.FormControlFocused = FormControlFocused;
var FormControlError = {
  color: _const.Colors.danger,
  border: "1px solid ".concat(_const.Colors.danger)
};
exports.FormControlError = FormControlError;
var FormControlSuccess = {
  color: _const.Colors.success,
  border: "1px solid ".concat(_const.Colors.success)
};
exports.FormControlSuccess = FormControlSuccess;
var formControlBasic = (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: block;\n  box-sizing: border-box;\n  appearance: none;\n"])));
exports.formControlBasic = formControlBasic;

var formControlSizeVariant = function formControlSizeVariant(measure) {
  return (0, _utils.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  line-height: ", "px;\n  padding: ", "px ", "px;\n"])), FormControlSize[measure].fontSize, FormControlSize[measure].lineHeight, FormControlSize[measure].paddingVertical, FormControlSize[measure].paddingHorizontal);
};

exports.formControlSizeVariant = formControlSizeVariant;

var formControlColorVariant = function formControlColorVariant() {
  return (0, _utils.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n\n  &.is-invalid {\n    border-color: ", ";\n  }\n  &.is-success {\n    border-color: ", ";\n\n    & + ", " {\n      opacity: 1;\n      z-index: 0;\n    }\n  }\n"])), FormControlDefault.color, FormControlDefault.backgroundColor, FormControlDefault.border, _const.Colors.danger, _const.Colors.success, _icon.IconStyled);
};

exports.formControlColorVariant = formControlColorVariant;
var formControlPlaceholder = (0, _utils.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &::-webkit-input-placeholder {\n    color: ", ";\n    text-transform: none;\n  }\n  &::-moz-placeholder {\n    color: ", ";\n    text-transform: none;\n  }\n  &:-ms-input-placeholder {\n    color: ", ";\n    text-transform: none;\n  }\n"])), FormControlDefault.placeholderColor, FormControlDefault.placeholderColor, FormControlDefault.placeholderColor);
exports.formControlPlaceholder = formControlPlaceholder;
var formControlFocusVariant = (0, _utils.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  &:focus {\n    border: ", ";\n    box-shadow: 0 0 0 2px rgba(0, 103, 244, 0.5);\n  }\n"])), FormControlFocused.border);
exports.formControlFocusVariant = formControlFocusVariant;
var formControlDisabledVariant = (0, _utils.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  &:disabled {\n    background-color: ", ";\n    border: ", ";\n  }\n"])), FormControlDisabled.backgroundColor, FormControlDisabled.border);
exports.formControlDisabledVariant = formControlDisabledVariant;